export default __webpack_public_path__ + "static/media/SAMMbe.54de3c03.jpeg";